export default __webpack_public_path__ + "static/media/help.4ba8af95.jpeg";